module.exports = __webpack_public_path__ + "3dfc0a740238fcf537d6ac9fb873d027.cur";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/cur/circle-40.cur
// module id = 457
// module chunks = 0